import validatorBuilder from 'validator-builder';

let prefaPrixValidator = null;

export default class PrefaPrix {
    constructor(data = {}) {
        this.id = data.id;
        this.type = data.type;
        this.estTransporte = data.estTransporte;
        this.dateModification = data.dateModification;
        this.achat = data.achat;
        this.grilleId = data.grilleId;
        this.produitId = data.produitId;
        this.producteurId = data.producteurId;
        this.prestationId = data.prestationId;
        this.zoneId = data.zoneId;
        this.benneId = data.benneId;
        this.siteId = data.siteId;
        this.prixCatalogue = data.modificationValeurCatalogue;
        this.prixCatalogue = data.modificationValeurStandard;
    }

    isValid() {
        prefaPrixValidator = prefaPrixValidator || validatorBuilder.getInstanceFor('PrefaPrix');
        const validationResults = prefaPrixValidator.validate(this);
        return validationResults.isValid;
    }
}
